import {FC, ReactNode} from "react";
import {createPortal} from "react-dom";
import {useModal} from "./useModal";

interface IProps {
    isOpen: boolean;
    close?: () => void;
    backgroundScroll?: boolean;
    closeOnOverlayClick?: boolean;
    children: ReactNode;
}

export const Modal: FC<IProps> = ({
    isOpen,
    children,
    close,
    closeOnOverlayClick = true,
    backgroundScroll = false,
}: IProps) => {
    const { handleClick, element } = useModal(
        isOpen,
        closeOnOverlayClick,
        backgroundScroll,
        close
    );

    if (!isOpen || !element) return null;

    return createPortal(
        <div
            className="fixed z-50 inset-0 bg-black/50 overflow-y-auto"
            onClick={handleClick}
        >
            <div onClick={(e) => e.stopPropagation()}>{children}</div>
        </div>,
        element
    );
};
